<template>
  <div id="ExternalLink" @click="openUrl()">
    <div class="ExternalLinkCon">
      <span class="Link-text1">Kanexthal
        <div class="Link-arrow">
           <img class="arrow-button" src="@/assets/img/ExternalLink_2.png" />
        </div>
      </span>
      <span class="Link-text2">Find Out More For β-thalassemia</span>
    </div>
    <img class="ExternalLink_1"  src="@/assets/img/ExternalLink_1.png" />
  </div>
</template>
<script>
export default {
  name: "ExternalLink",
  data() {
    return {
      flag: false
    };
  },
  methods: {
    openUrl() {
      //
       window.open('https://www.kanexthal.com/', '_blank')
    }
  }
};
</script>
<style scoped>
#ExternalLink {
  position: fixed;
  right: 20px;
  bottom: 120px;
  z-index: 99999999;
  cursor: pointer;
  background:#49A0BE;
  border-radius:7px;
  padding: 22px 15px;
  box-shadow:0 0 6px #0CA1E8;
  overflow: hidden;
  padding-right: 39px;
}
#ExternalLink:active{
  opacity: 0.9;
}
.ExternalLinkCon > span {
  display: block;
  color: #fff;
  font-size: 16px;
  line-height: 24px;
  height: 24px;
}
.ExternalLinkCon .Link-text1{
 font-size: 30px;
 height: 27px;
 line-height: 27px;
 margin-bottom: 2px;
 font-weight:600;
 position: relative;
 display: flex;
 align-items: center;
}
.ExternalLinkCon{
  position:relative;
  color:#fff;
}
.Link-arrow{
  background: #fff;
  width: 34px;
  height: 18px;
  border-radius: 9px;
  display: flex;
 align-items: center;
 justify-content: center;
 margin-left: 9px;
}
.ExternalLink_1{
  position: absolute;
  right: -14px;
  bottom: -14px;
  
}

.arrow-button {
    display: inline-block;
    font-size: 24px;
    animation: moveArrow 1s infinite linear;
}

@keyframes moveArrow {
    0% { transform: translateX(0); }
    50% { transform: translateX(4px); }
    100% { transform: translateX(0); }
}

</style>



// WEBPACK FOOTER //
// src/components/ExternalLink.vue